import * as String from "../../commons/string";
import Apollo3DView from "../../components/apollo3d/Apollo3DView";

/**
 * Apollo 경로·주행 제어 페이지(설계 R2, §11) — ADMIN/MANAGER 전용(라우트에서 권한 분리).
 * 모니터링과 동일한 3D 뷰(Apollo3DView)를 control 모드로 재사용해 경로 편집 + 주행 제어 오버레이를 켠다.
 */
const PageAutonomousRouting = () => {
    return (
        <div className="pageWrapper">
            <div style={{ margin: "16px 0 12px", fontWeight: 700, fontSize: "1.15rem" }}>
                {String.autonomousRouting}
            </div>
            <Apollo3DView mode="control" />
        </div>
    );
};

export default PageAutonomousRouting;
